'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherCheck, FeatherLoader, FeatherX } from '@subframe/core';
import Link from 'next/link';
import type { ReactNode } from 'react';
import { Checkbox, TextField } from '@/shared/components/ui';
import { ROTA_LOGIN } from '../constants';
import type { UseOnboardingSelfReturn } from '../hooks';
import type { CnpjStatus } from '../types';
import { WizardFooter } from './WizardFooter';
import { WizardHeader } from './WizardHeader';
interface EmpresaScreenProps {
  vm: UseOnboardingSelfReturn;
}
const CNPJ_STATUS_ERRO: CnpjStatus[] = ['invalido', 'jaCadastrada', 'indisponivel', 'muitasConsultas'];
const MENSAGEM_CNPJ: Partial<Record<CnpjStatus, string>> = {
  invalido: 'CNPJ inválido. Confira os números e tente novamente.',
  jaCadastrada: 'Empresa já cadastrada na plataforma Arbitralis.',
  indisponivel: 'Não conseguimos consultar a Receita agora.',
  muitasConsultas: 'Muitas consultas seguidas. Aguarde alguns minutos.'
};
export const EmpresaScreen = t0 => {
  const $ = _c(70);
  const {
    vm
  } = t0;
  const {
    empresa,
    cnpjStatus
  } = vm;
  let t1;
  if ($[0] !== cnpjStatus) {
    t1 = CNPJ_STATUS_ERRO.includes(cnpjStatus);
    $[0] = cnpjStatus;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cnpjTemErro = t1;
  const mensagemCnpj = cnpjTemErro ? MENSAGEM_CNPJ[cnpjStatus] : undefined;
  let t2;
  if ($[2] !== cnpjStatus || $[3] !== cnpjTemErro) {
    t2 = cnpjStatus === "consultando" ? <FeatherLoader className="animate-spin text-neutral-500" /> : cnpjStatus === "ok" ? <FeatherCheck className="text-success-700" /> : cnpjTemErro ? <FeatherX className="text-error-600" /> : null;
    $[2] = cnpjStatus;
    $[3] = cnpjTemErro;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const iconeCnpj = t2;
  let t3;
  if ($[5] !== vm.stepperSteps) {
    t3 = <WizardHeader steps={vm.stepperSteps} />;
    $[5] = vm.stepperSteps;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex flex-col gap-3"><h1 className="text-heading-dark text-2xl leading-tight font-semibold text-pretty sm:text-[30px]">Quem é você e qual é a sua empresa?</h1><p className="text-label-muted max-w-[420px] text-base leading-relaxed text-pretty">Essas informações confirmam sua empresa e garantem que só pessoas autorizadas atuem em nome dela.</p></div>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = cnpjStatus === "consultando";
  let t6;
  if ($[8] !== vm) {
    t6 = event => vm.atualizarCampo("cnpj", event.target.value);
    $[8] = vm;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== empresa.cnpj || $[11] !== t5 || $[12] !== t6) {
    t7 = <TextField.Input placeholder="00.000.000/0001-00" inputMode="numeric" autoComplete="off" aria-busy={t5} value={empresa.cnpj} onChange={t6} />;
    $[10] = empresa.cnpj;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== cnpjTemErro || $[15] !== iconeCnpj || $[16] !== t7) {
    t8 = <TextField className="w-full" label="CNPJ *" error={cnpjTemErro} iconRight={iconeCnpj}>{t7}</TextField>;
    $[14] = cnpjTemErro;
    $[15] = iconeCnpj;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== cnpjStatus || $[19] !== mensagemCnpj || $[20] !== vm.consultarCnpjDeNovo) {
    t9 = mensagemCnpj && <div className="flex items-center justify-between gap-3"><span className="text-error-700 text-xs" role="alert">{mensagemCnpj}</span>{cnpjStatus === "jaCadastrada" && <Link href={ROTA_LOGIN} className="text-brand-600 flex-none text-xs font-semibold whitespace-nowrap">Acessar minha conta →</Link>}{cnpjStatus === "indisponivel" && <button type="button" onClick={vm.consultarCnpjDeNovo} className="text-brand-600 flex-none cursor-pointer text-xs font-semibold whitespace-nowrap">Tentar novamente →</button>}</div>;
    $[18] = cnpjStatus;
    $[19] = mensagemCnpj;
    $[20] = vm.consultarCnpjDeNovo;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t8 || $[23] !== t9) {
    t10 = <div className="flex flex-col gap-1.5">{t8}{t9}</div>;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const t11 = cnpjStatus === "consultando" ? "Consultando a Receita..." : "Preenchida pelo CNPJ";
  let t12;
  if ($[25] !== t11 || $[26] !== vm.razaoSocialReceita) {
    t12 = <TextField className="w-full" variant="filled" label={"Raz\xE3o social *"} helpText="Preenchida automaticamente pelo CNPJ."><TextField.Input placeholder={t11} value={vm.razaoSocialReceita} readOnly={true} /></TextField>;
    $[25] = t11;
    $[26] = vm.razaoSocialReceita;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== vm) {
    t13 = event_0 => vm.atualizarCampo("responsavelNome", event_0.target.value);
    $[28] = vm;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== empresa.responsavelNome || $[31] !== t13) {
    t14 = <TextField className="w-full" label="Nome completo *"><TextField.Input placeholder="Ex: Mariana Costa" autoComplete="name" value={empresa.responsavelNome} onChange={t13} /></TextField>;
    $[30] = empresa.responsavelNome;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  const t15 = vm.emailInvalido ? "Digite um e-mail v\xE1lido." : vm.emailValido ? "Voc\xEA entra direto e confirma esse e-mail depois." : undefined;
  let t16;
  if ($[33] !== vm) {
    t16 = event_1 => vm.atualizarCampo("responsavelEmail", event_1.target.value);
    $[33] = vm;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== empresa.responsavelEmail || $[36] !== t16) {
    t17 = <TextField.Input placeholder="Ex: mariana@empresa.com.br" type="email" autoComplete="email" value={empresa.responsavelEmail} onChange={t16} />;
    $[35] = empresa.responsavelEmail;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t15 || $[39] !== t17 || $[40] !== vm.emailInvalido) {
    t18 = <TextField className="w-full" label="E-mail principal *" error={vm.emailInvalido} helpText={t15}>{t17}</TextField>;
    $[38] = t15;
    $[39] = t17;
    $[40] = vm.emailInvalido;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t14 || $[43] !== t18) {
    t19 = <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">{t14}{t18}</div>;
    $[42] = t14;
    $[43] = t18;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <span className="text-sm text-neutral-800">Li e aceito os{" "}<Link href="/termos-de-uso" target="_blank" rel="noopener noreferrer" className="text-brand-600 font-medium underline" onClick={_temp}>Termos de Uso</Link>{" "}da Arbitralis</span>;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== empresa.termosAceitos || $[47] !== vm.alternarTermos) {
    t21 = <Checkbox checked={empresa.termosAceitos} onCheckedChange={vm.alternarTermos} label={t20} />;
    $[46] = empresa.termosAceitos;
    $[47] = vm.alternarTermos;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== vm.recarregarTermos || $[50] !== vm.termosIndisponiveis) {
    t22 = vm.termosIndisponiveis && <div className="flex items-center justify-between gap-3"><span className="text-error-700 text-xs" role="alert">Não conseguimos carregar os Termos de Uso agora.</span><button type="button" onClick={vm.recarregarTermos} className="text-brand-600 flex-none cursor-pointer text-xs font-semibold whitespace-nowrap">Tentar novamente →</button></div>;
    $[49] = vm.recarregarTermos;
    $[50] = vm.termosIndisponiveis;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== t10 || $[53] !== t12 || $[54] !== t19 || $[55] !== t21 || $[56] !== t22) {
    t23 = <div className="flex flex-1 justify-center px-6 py-10 md:px-20 md:py-14"><div className="grid w-full max-w-[1280px] grid-cols-1 gap-10 lg:grid-cols-[minmax(280px,1fr)_minmax(420px,1.85fr)] lg:gap-20">{t4}<div className="flex w-full flex-col gap-5">{t10}{t12}{t19}{t21}{t22}</div></div></div>;
    $[52] = t10;
    $[53] = t12;
    $[54] = t19;
    $[55] = t21;
    $[56] = t22;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  let t24;
  if ($[58] !== vm) {
    t24 = () => vm.goTo("inicio");
    $[58] = vm;
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  let t25;
  if ($[60] !== vm) {
    t25 = () => vm.goTo("produtos");
    $[60] = vm;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  const t26 = !vm.podeAvancarEmpresa;
  let t27;
  if ($[62] !== t24 || $[63] !== t25 || $[64] !== t26) {
    t27 = <WizardFooter voltarLabel="Cancelar" onVoltar={t24} avancarLabel={"Confirmar e avan\xE7ar"} onAvancar={t25} avancarDisabled={t26} />;
    $[62] = t24;
    $[63] = t25;
    $[64] = t26;
    $[65] = t27;
  } else {
    t27 = $[65];
  }
  let t28;
  if ($[66] !== t23 || $[67] !== t27 || $[68] !== t3) {
    t28 = <div className="flex min-h-screen w-full flex-col bg-white">{t3}{t23}{t27}</div>;
    $[66] = t23;
    $[67] = t27;
    $[68] = t3;
    $[69] = t28;
  } else {
    t28 = $[69];
  }
  return t28;
};
function _temp(event_2) {
  return event_2.stopPropagation();
}